import { svg } from 'lit';

export const tableViewIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5C2 3.94772 2.44772 3.5 3 3.5H21C21.5523 3.5 22 3.94772 22 4.5V19.5C22 20.0523 21.5523 20.5 21 20.5H3C2.44772 20.5 2 20.0523 2 19.5V4.5ZM4 5.5V8.5H11V5.5H4ZM13 5.5V8.5H20V5.5H13ZM20 10.5H13V13.5H20V10.5ZM20 15.5H13V18.5H20V15.5ZM11 18.5V15.5H4V18.5H11ZM4 13.5H11V10.5H4V13.5Z" fill="currentColor"/>
  `;
